import type { DoodBlockScenarioMatrix } from './scenario-matrix';

/** Minimal context accepted by scenario factories (matches dood-config-core / dood-block-config). */
export type DefinitionScenarioContext = {
  activeTab?: string | null;
  props?: Record<string, unknown>;
};

export type DefinitionScenarioFactory<TContent = unknown> = (
  ctx: DefinitionScenarioContext,
) => DoodBlockScenarioMatrix<TContent>;

/** Compatibility default when a config does not declare preview fixtures. */
export const EMPTY_SCENARIO_FACTORY: DefinitionScenarioFactory = () => [];

/**
 * Binds a scenario factory to a literal `componentType` for the dashboard registry.
 * Content type is inferred from the factory's `content` layers.
 */
export type DefinitionSetupScenariosFn<ComponentType extends string> = <TContent>(
  factory: DefinitionScenarioFactory<TContent>,
) => {
  readonly componentType: ComponentType;
  readonly factory: DefinitionScenarioFactory<TContent>;
};

export function definitionSetupScenarios<const ComponentType extends string>(
  componentType: ComponentType,
): DefinitionSetupScenariosFn<ComponentType> {
  return factory => ({
    componentType,
    factory,
  });
}
